import { useState, useEffect, ChangeEvent } from 'react';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';

import { ReactComponent as FilterIcon } from '../assets/icons/main/filter-icon.svg';
import { ReactComponent as VrLine } from '../assets/icons/main/verticalLine.svg';
import { ReactComponent as RestoreIcon } from '../assets/icons/main/restore-icon.svg';

import SelectComponent from '../components/Select';

import Styles from '../theme/commonCss/Styles';
import { CircularProgress, Divider, darken, lighten, useMediaQuery, useTheme } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import { get } from 'lodash';



const FilterData = ({ ontologyData, showLayout, onOntoFilterChange, isError, handleRefresh,isOntoManagesLoading, isFrom, showReset, labelText, hideLine }: any) => {
  const themeParams :any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});  

  const FilterDataStyles = {
    horizontal: {
      wrapper: {
        // backgroundColor: lighten(themeParams.palette.background.default, 0.3),//'#F8FAFB80',
        // backgroundColor:lighten(themeParams.palette.background.default,0.2) ,//'#F8FAFB80',//for First Theme
        // backgroundColor: isFrom==='health' ? (themeMode.isLightBG) ? lighten(themeParams.palette.background.default, 0.2) : lighten(themeParams.palette.background.default, 0.08) : 'transparent',//'#F8FAFB80',//
        // borderBottom: '1px solid #D9DFED',
        // borderBottomColor:`${themeParams.palette.customBorderColor.main}`,//'#D9DFED'
        // borderTopLeftRadius: isFrom==='health' ? '18px' : '0px',
        // borderTopRightRadius:isFrom==='health' ? '18px' : '0px',
      },
      gridContainer: { display: 'flex', flexDirection: 'row' },
      box: { display: 'flex', flexDirection: 'row', width: '100%' },
      centerBox: { display: 'flex', flexDirection: 'row', alignItems: 'center', width : '130px' },
      centerBox2: { display: 'flex', flexDirection: 'row', alignItems: 'baseline' },
      filterByText: { margin: ' 0 12px', 
      color: themeParams.palette.text.primary,
      width: 'auto', minWidth:'92px',fontSize: '1rem'
    },
      // vrLineGrid: {
      //   display: 'flex',
      //   flexDirection: 'row',
      //   justifyContent: 'end',
      //   alignItems: 'center',
      //   color: '#51648f',
      // },
      vrLineGridIconButton: {
        marginLeft: '10px',
      },
    },
    vertical: {
      labelWrapper: {
        ...Styles.gridItem,
        '&.MuiGrid-item': {
          paddingTop: '22px !important',
        },
      },
      selectWrapper: { padding: '12px 0px !important' },
    },
  };

  const [levelData, setLevelData] = useState<any>(ontologyData);
  const [levelDataMain, setLevelDataMain] = useState<any>(ontologyData);
  const [isReset, setIsReset] = useState(false);

  useEffect(() => {
    setLevelData(
      ontologyData.map((items: any, index: number) => {
        if (index === 0) {
          return { ...items, show: true };
        }
        return { ...items };
      })
    );
    setLevelDataMain(ontologyData);
  }, [ontologyData]);

  const handleChange = (e: any, levelNum: number) => {
    setLevelData(
      levelData.map((items: any) => {
        if (items.level_number === levelNum) {
          return { ...items, selectedVal: e?.target.value };
        }
        if (items.level_number === levelNum + 1) {
          const filteredData = levelDataMain.filter((filterItems: any) => {
            return filterItems.level_number === levelNum + 1;
          });
          const filterOntology = filteredData[0].onto_manages.filter((filterItems: any) => {
            return filterItems.parent_id === e?.target.value;
          });

          if (filterOntology.length > 0) {
            return { ...items, show: true, selectedVal: null, onto_manages: filterOntology };
          } else {
            return { ...items, show: false, onto_manages: [], selectedVal: null };
          }
        }

        if (items.level_number >= levelNum + 2) {
          if (items.onto_manages.length > 0) {
            return { ...items, show: false, onto_manages: [], selectedVal: null };
          }
        }
        return { ...items };
      })
    );

    onOntoFilterChange({ onto_manage_id: e.target.value, level_number: levelNum });
  };

  useEffect(() => {
    if (isReset) {
      setLevelData(
        ontologyData.map((items: any, index: number) => {
          if (index === 0) {
            return { ...items, show: true };
          }
          return { ...items };
        })
      );
      setIsReset(false);
    }
  }, [isReset]);

  const handleFilterReload = () => {
    setLevelData([]);
    setIsReset(true);
    onOntoFilterChange({ onto_manage_id: 0, level_number: 0 });
    handleRefresh?.();
  };

  const mobileSize = useMediaQuery('(max-width:900px)');

  return (
    <>
      {showLayout ? (
        <>
        <Box sx={FilterDataStyles.horizontal.wrapper}>
          <Grid container>
            <Grid item xl={11} lg={11} md={11} sm={10} xs={8} sx={FilterDataStyles.horizontal.gridContainer}>
              <Box sx={FilterDataStyles.horizontal.box}>
                <Box sx={{ alignItems: 'center', display: 'flex', height: '42px' }}>
                  {(labelText) ?  <Box sx={{...FilterDataStyles.horizontal.centerBox, width:'145px' }}>                   
                    <Typography sx={FilterDataStyles.horizontal.filterByText}>{labelText} :</Typography>
                  </Box>:
                  <Box sx={FilterDataStyles.horizontal.centerBox}>
                    <FilterIcon style={{color:themeParams.palette.custom.light}} />
                    <Typography sx={FilterDataStyles.horizontal.filterByText}>Filter By :</Typography>
                  </Box>}
                </Box>

                <Grid container rowSpacing={4} columnSpacing={4}>
                  {isOntoManagesLoading ? (
                    <CircularProgress sx={{ ml: 3, mt: 4 }} size={25} />
                  ) : (
                    <>
                      {levelData.map((items: any, index: number) =>
                        items.show ? (
                          <Grid item sm={12} md={6} lg={4} xl={3} key={items.level_name}>
                            <SelectComponent
                              value={items.selectedVal || ''}
                              name={levelData.level_name}
                              options={items['onto_manages'].map((onto: any) => ({
                                ...onto,
                                label: onto.onto_manage_title,
                                value: onto.onto_manage_id,
                              }))}
                              placeholder={`Select ${items.level_name}`}
                              onChange={(event: ChangeEvent<HTMLSelectElement>) =>
                                handleChange(event, items.level_number)
                              }
                              error={isError && !items.selectedVal}
                              width='100%'
                            />
                          </Grid>
                        ) : (
                          ''
                        )
                      )}
                    </>
                  )}
                </Grid>

                {/* <SelectComponent
                                    value={selectedValue}
                                    onChange={handleCountryChange}
                                    options={countryList}
                                    placeholder={"Select Country"}
                                    color="secondary"
                                    style={{marginLeft:'15px', backgroundColor:'white'}} /> */}

                {/* <SelectComponent
                                    value={selectedStateValue}
                                    onChange={handleStateChange}
                                    options={stateList}
                                    placeholder={"Select Stae"}
                                    color="secondary" style={{marginLeft:'10px', backgroundColor:'white'}} /> */}
                {/* <Select
                                    id="cityName"
                                    variant='outlined'
                                    sx={{ marginLeft: '10px' }}
                                    placeholder='Select State'
                                >
                                    <MenuItem value={'MH'}>MH</MenuItem>
                                    <MenuItem value={'MP'}>MP</MenuItem>
                                </Select> */}
                {/* </Grid>
                </Grid> */}
              </Box>
            </Grid>
            <Grid item xl={1} lg={1} md={1} sm={2} xs={4}>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  height: '42px',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                }}
              >
                {!showReset && <>
                  {!hideLine && <VrLine style={{color:themeParams.palette.customBorderColor.main}}/>}
                <IconButton onClick={handleFilterReload} sx={FilterDataStyles.horizontal.vrLineGridIconButton}>
                  <RestoreIcon style={{color:themeParams.palette.custom.light}} />
                </IconButton>
                </>}
               
              </Box>
            </Grid>
          </Grid>
        </Box>

       {isFrom==='health' && <Divider />}
        </>
      ) : (
        levelData.map((items: any, idx: number) => {
          if (!items.show) return '';
          return (
            <Grid container key={idx * 2 + '_' + items.level_name + '_container'}>
              <Grid
                key={idx * 2 + '_' + items.level_name}
                item
                xs={12}
                sm={12}
                md={4}
                // key={items.level_name}
                sx={{
                  ...Styles.gridItem,
                  justifyContent: mobileSize ? 'flex-start' : 'flex-end',
                  padding: mobileSize ? '12px 0px 4px !important' : '22px 0px 0px !important',
                }}
              >
                <Typography sx={{...Styles.inputLabel, color: themeParams.palette.text.primary}} className={idx === 0 ? 'required-field' : ''}>
                  {items.level_name}
                </Typography>
              </Grid>
              <Grid
                key={idx * 4}
                item
                xs={12}
                sm={12}
                md={8}
                sx={{ padding: mobileSize ? '0px 0px 12px !important' : '12px 0px !important' }}
              >
                <SelectComponent
                  value={items.selectedVal || ''}
                  name={levelData.level_name}
                  options={items['onto_manages'].map((onto: any) => ({
                    ...onto,
                    label: onto.onto_manage_title,
                    value: onto.onto_manage_id,
                  }))}
                  placeholder={`Select ${items.level_name}`}
                  onChange={(event: ChangeEvent<HTMLSelectElement>) => handleChange(event, items.level_number)}
                  error={isError && !levelData[0].selectedVal}
                  helperText={`Please select ${items.level_name}`}
                />
              </Grid>
            </Grid>
          );
        })
      )}
    </>
  );
};

export default FilterData;
